 <template>
  <div> <div class="seachBox flex">

    <div class="seachList"><span class="name">客户名称：</span>
      <a-input placeholder="" class="seachs" v-model="seach.company"/>
    </div>

    <div class="seachList"><span class="name">总积分：</span>
      <a-input-number :precision="0" v-model="seach.score_min_num" class="num_input" />
      ~
      <a-input-number :precision="0" v-model="seach.score_max_num" class="num_input" />
    </div>

    <div class="seachList"><span class="name">兑换记录：</span>
      <a-select v-model="seach.is_audit" class="seachs" allowClear>
        <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.industry">
          {{item.name}}
        </a-select-option>
      </a-select>
    </div>
    <div class="seachList no"></div>
    <div class="seachList no"></div>
    <div class="seachList no"></div>
    <div class="seachList no"></div>
    <div class="  seachBtnBox"  >
      <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
        查询
      </a-button>
      <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
    </div>
  </div>
<!--    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"-->
    <a-table :columns="columns" :data-source="datas"   :pagination="pagination" rowKey="id">
        <a slot="details" slot-scope="text, record">
          <router-link :to="{ path:'/CustomerPoints/CustomerPointsDetails', query:{id:record.id}}"> 查看</router-link>
      </a>
      <span slot="is_audit" slot-scope="text, record">
       <a href="" v-if="text==1"><router-link :to="{ path:'/CustomerPoints/CustomerPointsDetails', query:{id:record.id,type:1}}"> 查看</router-link></a>
        <a href="" v-else ><router-link :to="{ path:'/CustomerPoints/CustomerPointsDetails', query:{id:record.id,type:2}}">审核</router-link></a>
      </span>

    </a-table></div>
</template>

<script>
import API from "./api/index"
const columns = [
  {
    title: "客户名称",
    dataIndex: "company",
    key: "company",
    width: "300px",
    ellipsis: true,
  },
  {
    title: "总积分",
    dataIndex: "score_num",
    ellipsis: true,
    width: "150px",
    key: "score_num",
  },
  {
    title: "现有积分",
    dataIndex: "score_left_num",
    ellipsis: true,
    width: "150px",
    key: "score_left_num",
  },
  {
    title: "积分明细",
    dataIndex: "details",
    ellipsis: true,
    width: "150px",
    key: "details",
    scopedSlots: {customRender: "details"}
  },
  {
    title: "兑换记录",
    key: "is_audit",
    dataIndex: "is_audit",
    width: "150px",
    scopedSlots: {customRender: "is_audit"}
  },

];
export default {
  name: "index",
  data(){
    return{
      seach: {
        company: "",
        is_audit: "",
        score_min_num: "",
        score_max_num: "",

      },
      seachList: {
        industry: [],
      },
      exportData:{},
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      datas: [],
      columns:columns,
      selectedRowKeys: [], // Check here to configure the default column
      loading: true,
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/DataStatistics/ProductArticle"; //设置左侧导航2-2 active
  },

  mounted() {
    this.getList()
    this.$store.state.company =""
  },
  methods:{
    resetSeach() {
      this.loading = true
      this.seach = {
        company: "",
        is_audit: "",
        score_min_num: "",
        score_max_num: "",
      }
      this.getList(1)
    },
    getList(page) {
      this.$message.destroy()
      let seachData = JSON.parse(JSON.stringify(this.seach))
      if(seachData.score_min_num*1<0|| seachData.score_max_num*1<0){
        this.$message.warning("请输入大于等于0的整数");
        return
      }
      if ( seachData.score_max_num!==""&&seachData.score_min_num!==""  &&seachData.score_max_num!==null&&seachData.score_min_num!==null ) {
        if(seachData.score_min_num*1 > seachData.score_max_num*1){
        this.$message.warning('后面数字不能小于前面数字');
        // 输入框数字需大于等于0，并且
        return
      }
      }
      this.exportData=seachData
      API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
        this.datas = res.data.data.info.data
        this.pagination.total = res.data.data.info.total
        this.pagination.pageSize = res.data.data.info.per_page
        this.pagination.current = res.data.data.info.current_page
        this.seachList.industry = res.data.data.status
        this.selectedRowKeys=[]
        this.loading = false
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
}
</script>

<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
  max-width: 228px;
}

.inputs {
  display: inline-block;
  width: 70px
}
.num_input{width:30%}
.seachBox .seachList {

  margin: 5px 0;
}
@media(max-width:1500px){
  .seachBox .seachList {
    width: 24.5%;
  }

}
</style>
